import { NavLink } from "react-router-dom";
import useFitText from "use-fit-text";
import { useState, useEffect } from "react";


export default function HomePage() {
    const { fontSize, ref } = useFitText();
    
    ////
    const [days, setDays] = useState(() => {
        const storedDays = localStorage.getItem("days");
        if (storedDays !== null) {
            return Number(storedDays);
        }

        const stored = localStorage.getItem("scoreStorage");
        if (!stored) return 0;
        const scores = JSON.parse(stored);
        const initialDays = scores.length || 0;
        localStorage.setItem("days", initialDays);
        return initialDays;
    });

    useEffect(() => {
        localStorage.setItem("days", days);
    }, [days]);

    const [showAnimatedGift, setShowAnimatedGift] = useState(() => {
        const lastCollected = localStorage.getItem("animatedGiftCollectedDate");
        if (!lastCollected) return true;

        const today = new Date();
        const last = new Date(lastCollected);

        const sameDay =
            today.getDate() === last.getDate() &&
            today.getMonth() === last.getMonth() &&
            today.getFullYear() === last.getFullYear();

        return !sameDay;
    });

    const [isLeft, setIsLeft] = useState(() => {
        const stored = localStorage.getItem("giftIsLeft");
        if (stored !== null) return stored === "true";

        const random = Math.random() < 0.5;
        localStorage.setItem("giftIsLeft", random);
        return random;
    });

    const handleAnimatedGiftClick = () => {
        const newDays = days + 1;
        setDays(newDays);

        const storage = localStorage.getItem("scoreStorage");
        const scores = storage ? JSON.parse(storage) : [];
        const today = new Date();

        scores.push({
            date: `${today.getDate()}.${today.getMonth() + 1}.${today.getFullYear()}`,
        });
        localStorage.setItem("scoreStorage", JSON.stringify(scores));

        localStorage.setItem("animatedGiftCollectedDate", today.toISOString());
        setShowAnimatedGift(false);

        // 🧹 очищаем позицию на следующий день
        localStorage.removeItem("giftIsLeft");
    };




    /////

    return (

        <div className="flex h-full w-full items-center justify-center bg-[url('/backGrounds/home.svg')] bg-contain">
            <div className="relative">
                <div className="absolute w-full h-[263px] flex justify-center z-0 lg:mt-[40px] xl:mt-[90px]">
                    <img
                        className="w-[426px] h-[120px] md:w-[603px] md:h-[160px] xl:w-[1074px] xl:h-[263px] lg:w-[884px] lg:h-[203px]"
                        src="./backGrounds/welcome_message.png"
                    />
                </div>
                <div className="absolute top-[65%] flex w-full">
                    <NavLink

                        to="/games/schulte/classic_asc"
                        className="relative mx-auto flex w-[16%] items-center justify-center px-4 text-center font-fredokaOne text-[20px] duration-100 hover:brightness-110 active:brightness-125 md:text-[30px] lg:text-[44px] xl:text-[60px]"
                        style={({ isActive, isPending }) => {
                            return {
                                color: isPending ? "red" : "inherit",
                            };
                        }}
                    >
                        <img
                            className="absolute object-contain"
                            src="./backGrounds/PlayButtonBg.svg"
                        />
                        <span
                            style={{ fontSize }}
                            ref={ref}
                            className="z-10 w-full truncate text-white"
                        >
                            PLAY
                        </span>
                    </NavLink>



                    <div className="absolute top-[14rem] left-[50%] flex flex-col items-center">
                        <img
                            src="gift.svg"
                            alt="Gift"
                            className="w-[10%] md:w-[8%] lg:w-[10%] object-contain -translate-x-2 -translate-y-2"
                        />
                        {days > 0 && (
                            <span className="absolute top-[-30%] left-[51%] text-purple-500 text-xl md:text-2xl lg:text-3xl font-fredokaOne drop-shadow-lg">
                                {days}
                            </span>
                        )}
                    </div>



                    {showAnimatedGift && (
                        <div
                            className="absolute bottom-[300%] flex flex-col items-center cursor-pointer"
                            style={{
                                left: isLeft ? "70%" : undefined,
                                right: !isLeft ? "70%" : undefined,
                            }}
                            onClick={handleAnimatedGiftClick}
                        >
                            <img
                                src="gift_animation.svg"
                                alt="Animated Gift"
                                className="w-[10%] md:w-[8%] lg:w-[10%] object-contain"
                                style={{ animation: "giftPulse 1.5s ease-in-out infinite" }}
                            />
                            <style>
                                {`
                                  @keyframes giftPulse {
                                    0%, 100% { transform: scale(1); }
                                    50% { transform: scale(1.3); }
                                  }
                                `}
                            </style>
                        </div>
                    )}

                </div>
                <img
                    className="max-h-screen object-contain"
                    src="./backGrounds/homeSvgs.svg"
                />
            </div>

        </div >
    );


}

